import { Component } from '@angular/core';

/**
 * @experimental
 */
@Component({
  selector: 'empty-parent-component',
  template: '<router-outlet></router-outlet>',
})
export class FramingEmptyParentComponent {}
